import { render } from "./JobTable.vue?vue&type=template&id=132a4ae6"
import script from "./JobTable.vue?vue&type=script&lang=js"
export * from "./JobTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__